module.exports = __webpack_public_path__ + "static/media/receta-02.2fba1b24.png";